@if (!isDashboardModule) {
<div class="panel-header">
    <h3 class="panel-title">Treasury Yield Curve</h3>
    <div class="panel-actions">
        <ycn-simple-dropdown
            class="page-header-action dropdown"
            buttonClass="btn btn-transparent2 dropdown-toggle"
            dropdownClass="dropdown-menu-with-icons dropdown-menu dropdown-menu-with-icons dropdown-menu-right"
            [config]="exportOptions"
            (handler)="handleExport($event)"
    ></ycn-simple-dropdown>
    </div>
</div>
}
<div class="panel-content">
    <div class="d-flex flex-wrap align-items-end gap-20px pt-10 pb-10">
        @for (dateSeries of dateSeries; track dateSeries.id) {
            <div class="d-flex flex-column gap-1">
                <div class="bullet bullet-{{ $index + 1 }}">
                    <span class="text-thin text-gray-40">Date {{ $index + 1 }}</span>
                </div>
                <ycn-single-date-picker
                    class="dropdown width-90"
                    [appendToBody]="true"
                    [selectedDate]="dateSeries.date"
                    (dateChangeHandler)="dateChangeHandler($event, $index)"
                ></ycn-single-date-picker>
            </div>
        }
        @if (canAddMoreDates && userCanEdit) {
            <button (click)="addDate()" class="btn btn-link"><span class="text-normal">+ Add Date</span></button>
        }
        @if (activeDatesCount > 1 && userCanEdit) {
            <button (click)="removeLastDate()" class="btn btn-link"><span class="text-normal">Remove</span></button>
        }
    </div>
    @if (isLoading) {
        <ycn-loading-symbol style="grid-template-columns: auto" loaderMessage="Loading..."></ycn-loading-symbol>
    } @else if(errorMessage) {
        <div style="height: 320px" class="relative">
            <div class="toast toast-error mt-20"><div class="toast-text">
                {{ errorMessage }}
            </div></div>
        </div>
    } @else {
        <div [id]="chartElemId" class="{{chartCssClass}} no-highcharts-darkmode-override"></div>
    }
</div>
<ycn-feature-needed #featureNeededComponent></ycn-feature-needed>
